<template>
  <div class="patient-detail" v-if="patient_detail">
    <div class="patient-box">
      <div class="patient-box-left font-85">姓名</div>
      <div class="patient-box-right font-65">{{patient_detail?patient_detail.realname:''}}</div>
    </div>
    <div class="patient-box">
      <div class="patient-box-left font-85">身份证号</div>
      <div class="patient-box-right font-65">{{patient_detail?patient_detail.idcard:''}}</div>
    </div>
    <div class="patient-box">
      <div class="patient-box-left font-85">性别</div>
      <div class="patient-box-right font-65">{{patient_detail?patient_detail.sex_name:''}}</div>
    </div>
    <div class="patient-box">
      <div class="patient-box-left font-85">年龄</div>
      <div class="patient-box-right font-65">{{patient_detail?patient_detail.age:''}}</div>
    </div>
    <div class="patient-box">
      <div class="patient-box-left font-85">关系</div>
      <div class="patient-box-right font-65">{{patient_detail.relation | rekation_status}}</div>
    </div>
    <div class="patient-box">
      <div class="patient-box-left font-85">联系电话</div>
      <div class="patient-box-right font-65">{{patient_detail?patient_detail.telphone:''}}</div>
    </div>
  </div>
</template>
<script>
import http from "../../request/http";

export default {
  name: "patient_detail",
  data() {
    return {
      patient_id: "",
      patient_detail: null,
    };
  },
  filters: {
    rekation_status(val) {
      let txt = "";
      switch (val) {
        case "1":
          txt = "本人";
          break;
        case "2":
          txt = "父母";
          break;
        case "3":
          txt = "爱人";
          break;
        case "4":
          txt = "子女";
          break;
        case "5":
          txt = "其他";
          break;
        default:
          txt = "";
      }
      return txt;
    },
  },
  created() {
    this.patient_id = this.$route.query.id;
    this.patinfo();
  },
  mounted() {},
  methods: {
    patinfo() {
      http
        .post("/api/wap/user/patientinfo", {
          pid: this.patient_id,
        })
        .then((res) => {
          res.data.sex_name = res.data.sex == 1 ? "男" : "女";
          this.patient_detail = res.data;
        });
    },
  },
};
</script>
<style scoped>
.patient-detail {
  width: 100vw;
  height: 100vh;
  background: #fafafa;
}
.patient-box {
  widows: 100%;
  height: 2.8rem;
  padding: 0 1rem;
  box-sizing: border-box;
  border-bottom: 0.05rem solid #f5f5f5;
  background: #fff;
}
.patient-box-left,
.patient-box-right {
  float: left;
  height: 2.8rem;
  line-height: 2.8rem;
  width: 3.8rem;
  font-size: 0.8rem;
}
.patient-box-right {
  width: calc(100% - 4.4rem);
  margin-left: 0.6rem;
}
</style>


// WEBPACK FOOTER //
// src/pages/patient/patient_detail.vue